import {useNavigate} from "react-router-dom";
import {useAuth} from "base/auth";

import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

const EntityCreateButton = () => {
    const navigate = useNavigate();
    const {isLoggedIn} = useAuth();

    return (
        isLoggedIn() && (
            <Button
                variant="contained"
                onClick={() => {
                    navigate("new");
                }}
                startIcon={<AddIcon />}
            >
                Crear
            </Button>
        )
    );
};
export default EntityCreateButton;
